import { createRoutine } from "redux-saga-routines";

export const anamnezRoutine = createRoutine("API_ANAMNEZ_GET");
export const userAnamnezRoutine = createRoutine("API_USER_ANAMNEZ_SAVE");
